export function formatNumber(value?: string | number, maximumFractionDigits = 3) {
    const number = Number(value ?? 0);
    return new Intl.NumberFormat("pt-BR", { maximumFractionDigits }).format(Number.isFinite(number) ? number : 0);
}

export function formatDate(value?: string) {
    if (!value) return "—";
    return new Intl.DateTimeFormat("pt-BR").format(new Date(value));
}

export function formatDateTime(value?: string) {
    if (!value) return "—";
    return new Intl.DateTimeFormat("pt-BR", { dateStyle: "short", timeStyle: "short" }).format(new Date(value));
}
